import { ArrowBack, ArrowForward } from '@mui/icons-material';
import {
  Box,
  Button,
  DialogActions,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DefaultModal from '../../components/Modals/DefaultModal';
import { Project } from '../../models/project';
import { CREATE_INVOICES } from '../../router/constants';
import { dashboardService } from '../../services/dashboardService';

interface Props {
  opened: boolean;
  closeModal: () => void;
}

const CreateInvoiceModal = (props: Props): JSX.Element => {
  const navigate = useNavigate();
  const [projects, setProjects] = useState<Project[]>([]);
  const [canContinue, setCanContinue] = useState<boolean>(false);
  const [selectedProject, setSelectedProject] = useState<string | undefined>(
    undefined
  );
  const handleClose = () => {
    setCanContinue(false);
    setSelectedProject(undefined);
    props.closeModal();
  };

  const getActiveProjects = () => {
    dashboardService
      .getTalentProjects({ params: { status: 'IN_PROGRESS' } })
      .then((response) => {
        setProjects(response.data.content);
      });
  };

  const formatProjectTitle = (title: string) => {
    if (title.length > 50) {
      return `${title.substring(0, 50)}...`;
    }
    return title;
  };

  const createInvoiceFromProject = () => {
    if (selectedProject) {
      navigate(`${CREATE_INVOICES}/${selectedProject}`);
    }
  };

  const handleSelectProject = (value: string) => {
    setCanContinue(true);
    setSelectedProject(value);
  };

  useEffect(() => {
    getActiveProjects();
  }, []);

  return (
    <>
      <DefaultModal open={props.opened} handleClose={handleClose}>
        <Box sx={{ px: 6 }}>
          <Typography variant="h4" textAlign="center" color="grey.900" mb={2}>
            Select a Project
          </Typography>
        </Box>
        <Box sx={{ px: 6 }}>
          <Typography
            variant="body1"
            textAlign="center"
            color="grey.900"
            mb={2}
          >
            Please select a project to continue:
          </Typography>
        </Box>
        <Box sx={{ mx: 6, maxHeight: 200, overflow: 'auto' }}>
          <RadioGroup
            onChange={(event) => handleSelectProject(event.target.value)}
          >
            {projects.map((project) => (
              <FormControlLabel
                key={project.id}
                value={project.id}
                control={<Radio />}
                sx={{ mb: 1 }}
                label={formatProjectTitle(project.projectTitle)}
              />
            ))}
          </RadioGroup>
        </Box>
        <DialogActions sx={{ justifyContent: 'center', pb: 3, pt: 3, gap: 2 }}>
          <Button
            startIcon={<ArrowBack />}
            onClick={handleClose}
            variant={'outlined'}
          >
            Back
          </Button>
          <Button
            disabled={!canContinue}
            endIcon={<ArrowForward />}
            onClick={createInvoiceFromProject}
          >
            Continue
          </Button>
        </DialogActions>
      </DefaultModal>
    </>
  );
};

export default CreateInvoiceModal;
